import React, { useState } from "react";
import axios from "axios";
import { createGlobalStyle } from "styled-components";
import { useNavigate } from "react-router-dom";
import SiteFooter from "../components/SiteFooter";

const Global = createGlobalStyle`
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #f0ebe3; font-family: 'Malgun Gothic','Apple SD Gothic Neo',Arial,sans-serif; }
`;

const API = process.env.REACT_APP_API_URL || "";

const SERVICE_TYPES = [
  "종합운세", "신년운세", "연애운", "결혼운",
  "직업운", "사업운", "건강운", "연애궁합", "심층궁합",
];

const wrap: React.CSSProperties = {
  maxWidth: 520, margin: "0 auto", padding: "32px 16px 80px",
};
const card: React.CSSProperties = {
  background: "#fff", borderRadius: 20, border: "1.5px solid #e0d5c8",
  padding: "28px 24px", boxShadow: "0 4px 24px rgba(100,70,40,0.08)",
};
const label: React.CSSProperties = {
  display: "block", fontSize: "0.78rem", fontWeight: 700,
  color: "#7a6654", marginBottom: 6,
};
const input: React.CSSProperties = {
  width: "100%", padding: "10px 12px", border: "1.5px solid #e0d5c8",
  borderRadius: 10, fontSize: "0.88rem", color: "#3d2b1f",
  background: "#fff", fontFamily: "inherit", marginBottom: 14,
};
const row: React.CSSProperties = {
  display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 14,
};
const btn: React.CSSProperties = {
  width: "100%", padding: "14px", background: "linear-gradient(135deg,#6b4c35,#3d2b1f)",
  color: "#fff", border: "none", borderRadius: 14,
  fontSize: "1rem", fontWeight: 800, cursor: "pointer", fontFamily: "inherit",
  boxShadow: "0 4px 16px rgba(61,43,31,0.2)",
};

export default function VisitPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "", email: "", phone: "", gender: "female",
    birth_year: "", birth_month: "", birth_day: "",
    birth_hour: "12", birth_type: "solar",
    service_type: "종합운세", memo: "", consent: false,
  });
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState("");
  const [done,    setDone]    = useState(false);

  const set = (k: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) =>
    setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.consent) { setError("개인정보 활용에 동의해주세요."); return; }
    if (!form.name || !form.birth_year || !form.birth_month || !form.birth_day) {
      setError("필수 항목(이름, 생년월일)을 모두 입력해주세요."); return;
    }
    if (!form.email) { setError("이메일 주소를 입력해주세요. 리포트 발송에 필요합니다."); return; }
    setLoading(true); setError("");
    try {
      await axios.post(`${API}/api/v1/visit/submit`, {
        name: form.name,
        email: form.email,
        phone: form.phone,
        gender: form.gender,
        birth_year:  parseInt(form.birth_year),
        birth_month: parseInt(form.birth_month),
        birth_day:   parseInt(form.birth_day),
        birth_hour:  parseInt(form.birth_hour) || 12,
        birth_type: form.birth_type,
        service_type: form.service_type,
        memo: form.memo,
        consent: true,
      });
      setDone(true);
    } catch (err: any) {
      setError(err.response?.data?.detail || "제출 중 오류가 발생했습니다.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <>
        <Global />
        <div style={wrap}>
          <div style={{ textAlign: "center", marginBottom: 28 }}>
            <div style={{ fontSize: "2.4rem" }}>🔮</div>
            <div style={{ fontSize: "1.4rem", fontWeight: 900, color: "#3d2b1f", marginTop: 6 }}>우연 사주</div>
          </div>
          <div style={{ ...card, textAlign: "center" }}>
            <div style={{ fontSize: "2.4rem", marginBottom: 12 }}>✅</div>
            <div style={{ fontSize: "1.1rem", fontWeight: 900, color: "#3d2b1f", marginBottom: 10 }}>
              방문 상담 접수 완료
            </div>
            <div style={{ fontSize: "0.85rem", color: "#7a6654", lineHeight: 1.8 }}>
              접수가 완료되었습니다.<br />
              {form.email && <>상담 후 분석 리포트를 <strong>{form.email}</strong>으로 보내드리겠습니다.<br /></>}
              문의: wooyeonsaju@gmail.com
            </div>
            <button
              onClick={() => { setDone(false); setForm({ name:"",email:"",phone:"",gender:"female",birth_year:"",birth_month:"",birth_day:"",birth_hour:"12",birth_type:"solar",service_type:"종합운세",memo:"",consent:false }); }}
              style={{ ...btn, marginTop: 20, background: "linear-gradient(135deg,#c09a6b,#a07850)" }}
            >
              새 접수하기
            </button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Global />
      <div style={wrap}>
        {/* 네비게이션 */}
        <div style={{ display: "flex", alignItems: "center", marginBottom: 16 }}>
          <button
            onClick={() => navigate("/")}
            style={{
              display: "flex", alignItems: "center", gap: 6,
              background: "rgba(255,255,255,0.7)", border: "1.5px solid #e0d5c8",
              borderRadius: 20, padding: "7px 14px", cursor: "pointer",
              fontSize: 13, fontWeight: 700, color: "#7a6654",
              fontFamily: "inherit", boxShadow: "0 2px 8px rgba(100,70,40,0.08)",
            }}>
            ← 홈
          </button>
          <div style={{ flex: 1, textAlign: "right", fontSize: 15, fontWeight: 900, color: "#3d2b1f" }}>🏠 방문 상담 사주</div>
        </div>

        {/* 헤더 */}
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div style={{ fontSize: "2rem", marginBottom: 6 }}>🏠</div>
          <div style={{ fontSize: "1.4rem", fontWeight: 900, color: "#3d2b1f", marginTop: 6 }}>방문 상담 사주</div>
          <div style={{ fontSize: "0.8rem", color: "#9c7b5a", marginTop: 4 }}>1:1 대면 상담 후 명리학 분석 리포트 이메일 발송</div>
        </div>

        <div style={card}>
          <div style={{ display: "inline-block", padding: "5px 14px", background: "#6b4c3520", border: "1.5px solid #6b4c3540", borderRadius: 20, fontSize: "0.75rem", fontWeight: 700, color: "#6b4c35", marginBottom: 20 }}>
            🏠 방문 상담 — 상담 후 리포트를 이메일로 발송해드립니다
          </div>

          <form onSubmit={handleSubmit}>
            {/* 이름 + 성별 */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 0 }}>
              <div>
                <label style={label}>이름 *</label>
                <input style={input} value={form.name} onChange={set("name")} placeholder="홍길동" required />
              </div>
              <div>
                <label style={label}>성별 *</label>
                <select style={input} value={form.gender} onChange={set("gender")}>
                  <option value="female">여성</option>
                  <option value="male">남성</option>
                </select>
              </div>
            </div>

            {/* 생년월일 */}
            <label style={label}>생년월일 *</label>
            <div style={row}>
              <input style={input} value={form.birth_year}  onChange={set("birth_year")}  placeholder="1990" maxLength={4} />
              <input style={input} value={form.birth_month} onChange={set("birth_month")} placeholder="월 (1~12)" maxLength={2} />
              <input style={input} value={form.birth_day}   onChange={set("birth_day")}   placeholder="일" maxLength={2} />
            </div>

            {/* 태어난 시간 + 양음력 */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 0 }}>
              <div>
                <label style={label}>태어난 시(時)</label>
                <select style={input} value={form.birth_hour} onChange={set("birth_hour")}>
                  {Array.from({ length: 24 }, (_, i) => (
                    <option key={i} value={i}>{i}시</option>
                  ))}
                  <option value="99">모름</option>
                </select>
              </div>
              <div>
                <label style={label}>양/음력</label>
                <select style={input} value={form.birth_type} onChange={set("birth_type")}>
                  <option value="solar">양력</option>
                  <option value="lunar">음력</option>
                </select>
              </div>
            </div>

            {/* 연락처 + 이메일 */}
            <label style={label}>이메일 (리포트 수령용) *</label>
            <input style={input} type="email" value={form.email} onChange={set("email")} placeholder="example@email.com" required />

            <label style={label}>전화번호</label>
            <input style={input} value={form.phone} onChange={set("phone")} placeholder="010-0000-0000" />

            {/* 서비스 종류 */}
            <label style={label}>상담 종류 *</label>
            <select style={input} value={form.service_type} onChange={set("service_type")}>
              {SERVICE_TYPES.map(s => <option key={s} value={s}>{s}</option>)}
            </select>

            {/* 메모 */}
            <label style={label}>상담 요청 내용 (선택)</label>
            <textarea
              style={{ ...input, height: 80, resize: "vertical" }}
              value={form.memo}
              onChange={set("memo")}
              placeholder="궁금하신 점이나 원하시는 상담 내용을 간단히 적어주세요."
            />

            {/* 동의 */}
            <label style={{ display: "flex", alignItems: "flex-start", gap: 8, fontSize: "0.78rem", color: "#7a6654", marginBottom: 20, cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={form.consent}
                onChange={e => setForm(f => ({ ...f, consent: e.target.checked }))}
                style={{ marginTop: 2, accentColor: "#c09a6b" }}
              />
              <span>
                개인정보(생년월일, 이메일 등)를 사주 분석 및 서비스 제공 목적으로 수집·이용하는 것에 동의합니다. *
              </span>
            </label>

            {error && (
              <div style={{ padding: "10px 14px", background: "#fff5f5", border: "1px solid #ffc9c9", borderRadius: 10, fontSize: "0.82rem", color: "#c92a2a", marginBottom: 14 }}>
                {error}
              </div>
            )}

            <button type="submit" style={btn} disabled={loading}>
              {loading ? "접수 중..." : "방문 상담 접수하기"}
            </button>
          </form>
        </div>

        {/* 안내 */}
        <div style={{ marginTop: 16, padding: "14px 16px", background: "#faf5ef", borderRadius: 14, border: "1px solid #e8d8c4", fontSize: "0.78rem", color: "#9c7b5a", lineHeight: 1.8 }}>
          · 접수 후 상담 시 추가 정보를 확인할 수 있습니다.<br />
          · 분석 리포트는 상담 완료 후 이메일로 발송됩니다.<br />
          · 문의: wooyeonsaju@gmail.com
        </div>
        <SiteFooter />
      </div>
    </>
  );
}
